module.exports = __webpack_public_path__ + "team-bottom.svg?6e0a28dcaccac60a6f794d1ce3b08dc0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/team-bottom.svg
// module id = 82
// module chunks = 0